import { createFileRoute, Link, useRouter } from "@tanstack/react-router"
import { useServerFn } from "@tanstack/react-start"

import config from "@/config"

import { BrandingSettings } from "../components/branding-settings"
import { PageError, PageLoading } from "../components/page-state/page-state"
import { deleteLogoAction, loadBranding, updateBrandingAction, uploadLogoAction } from "../rpc"

export const Route = createFileRoute("/_app-shell/invoices/branding")({
  loader: () => loadBranding(),
  head: () => ({
    meta: [
      { title: `Invoice branding - ${config.core.projectName}` },
      { name: "robots", content: "noindex" },
    ],
  }),
  pendingComponent: () => (
    <PageLoading title="Invoice branding" label="Loading your invoice branding" />
  ),
  errorComponent: ({ error }) => {
    const router = useRouter()
    return (
      <PageError
        title="Invoice branding"
        message={error.message || "Invoice branding could not be loaded."}
        onRetry={() => router.invalidate()}
      />
    )
  },
  component: InvoiceBrandingRoute,
})

function InvoiceBrandingRoute() {
  const view = Route.useLoaderData()
  const router = useRouter()
  const update = useServerFn(updateBrandingAction)
  const upload = useServerFn(uploadLogoAction)
  const remove = useServerFn(deleteLogoAction)

  return (
    <main className="mx-auto w-full max-w-7xl space-y-6 px-6 py-8">
      <div className="space-y-1">
        <Link to="/invoices" className="text-muted-foreground text-sm underline underline-offset-4">
          Back to invoices
        </Link>
        <h1 className="text-2xl font-semibold tracking-tight">Invoice branding</h1>
        <p className="text-muted-foreground text-sm">
          Your logo and colour on every invoice and receipt. You can skip this: invoices then show
          your business name and use the Classic template.
        </p>
      </div>
      <BrandingSettings
        view={view}
        onUpdate={(request) => update({ data: request })}
        onUploadLogo={(file) => {
          const form = new FormData()
          form.set("file", file)
          return upload({ data: form })
        }}
        onDeleteLogo={() => remove()}
        // re-fetch so the page never shows a stale logo or colour
        onSaved={() => void router.invalidate()}
      />
    </main>
  )
}
